import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/people` URL — what the embedded app and every existing
 * link point at. It always forwards to the Hydra page.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the
 * `journeys` segment, so the resolver's bundle-aware branch can rebuild the
 * target from the bundle prefix when the `/workspaces/last` sentinel needs
 * resolving.
 */
function JourneysPeopleIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/')({
  component: JourneysPeopleIndexRoute,
});
